/**
 * Absolute URL for the 404 illustration (served from `public/illustrations/`).
 * Avoids bundler/TS resolution issues when the page is plain JSX.
 */
export function getNotFound404IllustrationSrc() {
    const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    return `${base}/illustrations/not-found-404.svg`;
}
